import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'getProperty'
})
export class GetPropertyPipe implements PipeTransform {
    transform(obj: any, path: string, orderFlag?: boolean, keepCaseSensitivity?: boolean): any {
        let output: any = '';
        let reduced = this.propertyReducer(obj, path);
        switch (true) {
            case /GRADE/.test(path):
                if (orderFlag) {
                    switch (reduced.toString()) {
                        case '':
                            output = 0;
                            break;
                        case 'P0':
                            output = 10;
                            break;
                        case 'P1':
                            output = 11;
                            break;
                        case 'P2':
                            output = 12;
                            break;
                        case 'P3':
                            output = 13;
                            break;
                        case 'P4':
                            output = 14;
                            break;
                        case 'P5':
                            output = 15;
                            break;
                        case 'P6':
                            output = 16;
                            break;
                        case 'PK':
                            output = 17;
                            break;
                        case 'TK':
                            output = 18;
                            break;
                        case 'K':
                            output = 30;
                            break;
                        case '01':
                            output = 31;
                            break;
                        case '02':
                            output = 32;
                            break;
                        case '03':
                            output = 33;
                            break;
                        case '04':
                            output = 34;
                            break;
                        case '05':
                            output = 35;
                            break;
                        case '06':
                            output = 36;
                            break;
                        case '07':
                            output = 37;
                            break;
                        case '08':
                            output = 38;
                            break;
                        case '09':
                            output = 39;
                            break;
                        case '10':
                            output = 40;
                            break;
                        case '11':
                            output = 41;
                            break;
                        case '12':
                            output = 42;
                            break;
                        case 'AD':
                            output = 71;
                            break;
                        case 'UG':
                            output = 72;
                            break;
                        case 'NA':
                            output = 73;
                            break;
                        default:
                            output = 99;
                            break;
                    }
                } else {
                    output = reduced.toString();
                }
                break;
            case /length/.test(path):
                output = reduced.toString().toLowerCase();
                break;
            // Tries to find a number, but not a date (ie. 01-01-2001, 01/01/2001, 2001-01-01)
            case /(?<![\d\/-])\d*(?![\d\/-])/.test(reduced):
                if (typeof reduced == 'boolean') {
                    output = reduced;
                } else if (typeof reduced === 'object' && !Array.isArray(reduced) && reduced !== null) {
                    output = reduced;
                } else if (isNaN(reduced)) {
                    if (keepCaseSensitivity) {
                        output = reduced.toString();
                    } else {
                        output = reduced.toString().toLowerCase();
                    }
                } else if (reduced === null) {
                    output = 0;
                } else {
                    let num = reduced;

                    if (reduced.toString().length === 0) {
                        output = 0;
                    } else if (num === 0) {
                        output = 0;
                    } else {
                        output = parseInt(num);
                    }
                }
                break;
            default:
                output = reduced.toString().toLowerCase();
                if (moment(output).isValid() && output.length >= 10) {
                    output = new Date(output);
                }
                break;
        }

        return output;
    }

    propertyReducer(obj: any, path: string) {
        let reduced = path.split('.').reduce((o, p) => {
            // Handle arrays
            if (p.indexOf('[') > 0) {
                let obj = p.slice(0, p.length - 3);
                let pos = p.slice(p.indexOf('[') + 1, p.indexOf(']'));

                return o && (o || {})[obj] && (o || {})[obj][pos];
            } else {
                return o && (o || {})[p];
            }
        }, obj);

        if (isNaN(reduced)) {
            return reduced || '';
        } else {
            return reduced;
        }
    }
}
